import ITranslation from "@/interfaces/ITranslation";

// cSpell:locale en es
// cSpell:disable

const Es: ITranslation = {
  name: "Camarero Digital",
  description: "Más sabor para tu negocio",
  table: "Mesa",
  command: "Comanda",
  promotion: "Promoción",
  feedback: "Calificación",
  noneFound: "¡No se encontró nada!",
  tryRemoveFilter: "Intenta eliminar un filtro",
  priceFrom: "Desde",
  subtotal: "SubTotal",
  total: "Total",
  paidOut: "Pagado",
  totalToPay: "Cantidad a pagar",
  serviceTax: "Servicio",
  optional: "Opcional",
  additions: "Suma",
  discount: "Descuento",
  details: "Detalles",
  about: "Acerca de POP Pedidos",
  qrScanner: {
    scanner: "Escáner",
    search: "Búsqueda",
    installApp: "Instalar Camarero Digital",
    scanAnotherCode: "Escanear otro código",
    cannotAccessCamera: "No se puede acceder a la cámara",
    enterQrCode:
      "Ingrese el código de la tabla a continuación, ¡está debajo del código QR!",
    enterCommandQrCode:
      "Ingrese el código de comando a continuación, ¡está debajo del código QR!",
    requiredCameraPermission: "Requiere acceso a la cámara",
    requireCameraPermission:
      "Para escanear el Código QR de la mesa, permita que el Camarero Digital acceda a la cámara",
    manualQrCode: "Ingrese el código manualmente",
    readQrCodeToAccess: <>Para acceder, apunte la cámara al código QR de la mesa</>,
    readCommandQrCodeToAccess: (
      <>Para acceder, apunte la cámara al código QR del comando</>
    ),
    cannotAccessTablet: "No eres dueño del Camarero Digital",
    needInstallApp: (
      <>
        Está utilizando Digital Waiter en <b>modo Tablet at Table</b>,<br />
        para disfrutar de todas las funciones es <b>necesario</b> instalar el nuestra
        aplicación!
      </>
    ),
  },
  modal: {
    success: "¡Éxito!",
    thanks: "¡Gracias!",
    okThanks: "¡Está bien, gracias!",
    close: "Cerca",
    save: "Guardar",
    back: "Regresar",
    confirm: "Confirmar",
    notNow: "Ahora no",
    waiter: {
      extraCup: "Copa Extra",
      cupWithIce: "Copa con hielo",
      extraCutlery: "Cubertería extra",
      extraDish: "Plato extra",
      clearTable: "Borrar tabla",
      anotherReasons: "Otras razones",
      callNow: "Llamar ahora",
      callWaiter: "Llamar al camarero",
      rateLimit: "Espera un momento,\n¡estás llamando al camarero demasiado rápido!",
      called: (
        <>
          El camarero fue llamado,
          <br />
          ¡Te responderemos en unos momentos!
        </>
      ),
    },
    language: {
      title: "Cambia el idioma",
      confirm: "Confirmar",
      portuguese: "Portugués",
      brazil: "Brasil",
      english: "Inglés",
      unitedStates: "Estados Unidos",
      spanish: "Español",
      spain: "España",
    },
    account: {
      title: "Mi cuenta",
      empty: "¡Nada en tu cuenta todavía!",
      splitBillQuestion: "¿Vas a dividir la cuenta?",
      personsNumbers: "Nº de personas",
      valuePerPerson: "Valor por persona",
      requestAccount: "Solicitar cuenta",
    },
    cart: {
      title: "Carrito de la compra",
      empty: "¡El carrito está vacío!",
      sendOrder: "Hacer pedido",
      orderPaused: "Mesa cerrada",
      orderSended: (
        <>
          ¡Tu pedido ha sido registrado con éxito!
          <br />
          <br />
          Para obtener más información sobre sus pedidos, utilice la opción &quot;Mi
          cuenta&quot;
          <br />
          <br />
          En caso de duda no dude en llamar al camarero ✨
        </>
      ),
      belongsAnother: "Este código pertenece a otra tabla",
    },
    feedback: {
      title: "Calificación",
      thanks: "¡Éxito! ¡Gracias por tomarse el tiempo para darnos una reseña!",
      didYouThink: "¿Qué te pareció nuestro servicio?",
      opinionImportant: "¡Tu opinión es muy importante, deja tu reseña abajo!",
      yourName: "Tu nombre",
      whatMainReason: "¿Cuáles son las principales razones de su calificación?",
      required:
        "Debe calificar todas las opciones para enviar su revisión, los campos de nombre y mensaje son opcionales",
      send: "Enviar calificación",
    },
    poweredBy: {
      title: (
        <>
          El camarero digital que <b>impresionará</b> a tus clientes
        </>
      ),
      ordersOnTable: "Pedidos sobre la mesa",
      selfService: "Autoservicio",
      innovationAndTechnology: "Innovación y tecnología",
      andMuchMore: (
        <>
          E <b>muuito</b> mais!
        </>
      ),
    },
    product: {
      close: "Cerrar producto",
      next: "Siguiente",
      update: "Actualizar",
      add: "Agregar",
      anyObservation: "¿Alguna observación?",
      observationExample:
        "Ejemplo: Retire la cebolla y el tomate, aparte la mayonesa, etc.",
      quantity: "Cantidad",
      quantityAndObservation: "Cantidad y Observación",
      unavailable: "En este momento no esta disponible",
      select: "Seleccione",
      flavor: "Sabor",
      or: "o",
      to: "a",
      option: "opcione",
      options: "opciones",
      until: "hasta",
    },
    qrCodeConfirm: {
      title: "Confirmación de mesa",
      titleCommand: "Confirmación de comando",
    },
    setupTable: {
      title: "Numero de mesa",
      message: "Ingrese el número de su mesa a continuación:",
    },
    confirmOrder: {
      title: "¿Confirmas que el pedido ha sido enviado?",
      message:
        "Una vez confirmado, su pedido será enviado y no podrá modificarse ni cancelarse.",
    },
    table: {
      restrictArea: "Área restringida",
      title: "Opciones de tabla",
      mode: "Operación",
      typePassword: "Ingrese la contraseña",
      tableNumber: "Número de tabla",
      requestTableNumberInput: "Ask",
      reduceMotion: "Reducir animaciones y efectos",
      autoBrightness: "Brillo automático",
      clearTable: "Borrar tabla",
      clearAndCloseTable: "Borrar y cerrar tabla",
      signOut: "Abandonar el Camarero Digital",
      integrated: "¡Esta mesa está integrada!",
      signOutConfirm: "Haga clic de nuevo para salir",
      buffet: "Rodízio",
    },
    installApp: {
      appName: "Camarero Digital",
      configure: "Para configurar",
      configureHomeScreen: (
        <>
          Estás en modo <b>Tablet at Table</b>, para una mejor experiencia
          <b>recomendamos</b> configurar Digital Waiter como aplicación
          <b>pantalla de inicio predeterminada</b>!
        </>
      ),
    },
    deviceNotAuthorized: {
      title: "¡No autorizado!",
      message: "Has sido desconectado.",
    },
    orderPaused: {
      title: "¡Mesa receptora!",
      message: "No se pueden realizar pedidos mientras la mesa está recibiendo.",
    },
  },
  error: {
    pageNotFound: "Esta página no fue encontrada",
    unexpectedError: "Ocurrió un error inesperado",
    serverError: "Ha ocurrido un error en el servidor",
    clientError: "Error de aplicación: se produjo una excepción del lado del cliente",
  },
};

export default Es;
